import { CircleIcon, IconCheck } from '@/assets/icons';
import { cn, NOOP } from '@/utils';
import { memo } from 'react';

export type CheckboxFormProps = {
	checked: boolean;
	className?: string;
	value: string;
	name?: string;
	onClick?: (e: React.MouseEvent<HTMLElement>) => void;
	iconType?: 'checkbox' | 'circle' | 'square';
	iconClassName?: string;
	disabled?: boolean;
};

const CheckboxForm = ({
	className,
	checked,
	value,
	onClick,
	name,
	iconType = 'checkbox',
	iconClassName,
	disabled,
}: CheckboxFormProps) => {
	const renderIcon = () => {
		switch (iconType) {
			case 'checkbox':
				return (
					<IconCheck
						className={cn(
							'w-full h-full transition-all',
							checked ? 'block' : 'hidden',
							iconClassName
						)}
					/>
				);
			case 'circle':
				return (
					<CircleIcon
						className={cn(
							'w-full h-full transition-all',
							checked ? 'block' : 'hidden',
							iconClassName
						)}
					/>
				);
			case 'square':
				return (
					<div
						className={cn(
							'w-full h-full transition-all bg-black',
							checked ? 'block' : 'hidden',
							iconClassName
						)}
					></div>
				);
			default:
				return null;
		}
	};

	return (
		<div
			accessKey={name}
			className={cn('w-5 h-5 cursor-pointer', className)}
			data-value={value}
			data-name={name}
			onClick={disabled ? NOOP : onClick}
		>
			{renderIcon()}
		</div>
	);
};

export default memo(CheckboxForm);
